import React from "react";
import LegalDoc from "../components/Layout/LegalDoc";
import useSEO from "../hooks/useSEO";

const TermsOfService = () => {
  useSEO({
    title: "Terms of Service",
    description:
      "The terms that govern your use of the MandapAI marketplace, website and mobile app.",
    path: "/terms",
  });
  return (
  <LegalDoc
    title="Terms of Service"
    updated="June 7, 2026"
    intro="These Terms of Service govern your use of the MandapAI marketplace, website, and mobile app. By accessing or using our services, you agree to these terms."
    sections={[
      {
        heading: "Eligibility",
        body: "You must be at least 18 years old and able to form a legally binding contract to use MandapAI. By using the platform you confirm that the information you provide is accurate and complete.",
      },
      {
        heading: "Accounts",
        body: [
          "You are responsible for maintaining the confidentiality of your account credentials.",
          "You are responsible for all activity that occurs under your account.",
          "Notify us immediately of any unauthorized use of your account.",
        ],
      },
      {
        heading: "Vendor Responsibilities",
        body: [
          "Provide accurate listings, pricing, availability, and business details.",
          "Honour confirmed bookings and deliver services as described.",
          "Comply with all applicable laws, licenses, and tax obligations.",
        ],
      },
      {
        heading: "Customer Responsibilities",
        body: [
          "Provide accurate event details when requesting or making a booking.",
          "Make payments through approved methods on the platform.",
          "Communicate respectfully with vendors and our support team.",
        ],
      },
      {
        heading: "Bookings & Payments",
        body: "MandapAI facilitates bookings between customers and vendors. Applicable platform fees or commissions will be disclosed before a transaction. Cancellations and refunds are subject to the policy shown at the time of booking.",
      },
      {
        heading: "Prohibited Conduct",
        body: [
          "Posting false, misleading, or fraudulent content.",
          "Circumventing the platform to avoid fees, or harvesting user data.",
          "Uploading malicious code or attempting to disrupt the service.",
        ],
      },
      {
        heading: "Intellectual Property",
        body: "All trademarks, logos, and content on the platform are owned by MandapAI or its licensors and may not be used without permission.",
      },
      {
        heading: "Limitation of Liability",
        body: "MandapAI acts as a marketplace and is not a party to the contract between customers and vendors. To the maximum extent permitted by law, we are not liable for indirect or consequential damages arising from your use of the services.",
      },
      {
        heading: "Termination",
        body: "We may suspend or terminate accounts that violate these terms or harm the platform, other users, or third parties.",
      },
      {
        heading: "Changes to These Terms",
        body: "We may update these terms periodically. Continued use of the platform after changes take effect constitutes acceptance of the revised terms.",
      },
    ]}
  />
  );
};

export default TermsOfService;
